var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAttachment(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 20,
    viewBox: "0 0 18 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.4429 10.4219L8.30029 16.5645C6.76465 18.1167 4.69775 17.9673 3.36963 16.6392C2.0332 15.311 1.89209 13.2524 3.44434 11.7002L11.8613 3.2832C12.7495 2.39502 14.0859 2.2124 14.9575 3.09229C15.8374 3.98047 15.6548 5.30029 14.7666 6.18848L6.48242 14.481C6.14209 14.8296 5.74365 14.73 5.50293 14.4976C5.27881 14.2651 5.1875 13.8667 5.52783 13.5264L11.2969 7.74902C11.6123 7.43359 11.6289 6.96045 11.3218 6.65332C11.0146 6.35449 10.5415 6.36279 10.2261 6.67822L4.42383 12.4805C3.50244 13.4019 3.54395 14.8213 4.36572 15.6431C5.25391 16.5312 6.59863 16.5063 7.52832 15.585L15.854 7.25098C17.4976 5.60742 17.4478 3.44922 16.0034 1.99658C14.5757 0.585449 12.376 0.494141 10.7324 2.12939L2.25732 10.6211C0.124023 12.7544 0.265137 15.8423 2.21582 17.793C4.1665 19.7354 7.25439 19.8848 9.3877 17.7515L15.5801 11.5591C15.8872 11.2603 15.8789 10.6958 15.5635 10.4053C15.2646 10.0815 14.7583 10.1147 14.4429 10.4219Z",
    fill: "#9087A7"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAttachment);
export default __webpack_public_path__ + "static/media/attachment.3c8c7d020d22d6a7798f445054a4ba02.svg";
export { ForwardRef as ReactComponent };